import TowerService from '../services/tower.service'
import {
  _COMMIT_LOG, TOWER_GET_TOWERS, TOWER_GET_APS, TOWER_GET_SUBS,
} from './actions.types'
import {
  TOWER_SET_TOWERS, TOWER_SET_TOWER_APS, TOWER_SET_TOWER_SUBS,
} from './mutations.types'
import PowCustomerService from '../services/pow-customer.service'

const initialState = {
  towers: [],
  towerAps: [],
  towerSubs: [],
}
export const state = { ...initialState }

export const actions = {
  async [TOWER_GET_TOWERS] ({ dispatch, commit, rootState, state }, payload) {
    try {
      dispatch(_COMMIT_LOG, { message: 'Retrieving system owers', payload })
      const { data } = await TowerService.get()
      commit(TOWER_SET_TOWERS, data)
      return data
    } catch (e) {
      const processedError = await dispatch('processAxiosError', e)
      dispatch(_COMMIT_LOG, { message: 'Exception retrieving system towers', error: processedError })
      return []
    }
  },
  /***
   * Get Access Points for a tower
   * @param {string} payload.rowkey get access points assigned to a tower
   * @returns {*}
   */
  async [TOWER_GET_APS] ({ dispatch, commit, rootState, state }, payload) {
    try {
      dispatch(_COMMIT_LOG, { message: 'Retrieving access points for tower', payload })
      const { data } = await TowerService.getTowerAps(payload.rowkey)
      commit(TOWER_SET_TOWER_APS, data)
      return data
    } catch (e) {
      const processedError = await dispatch('processAxiosError', e)
      dispatch(_COMMIT_LOG, { message: 'Exception retrieving tower access points', error: processedError })
      return []
    }
  },
  /***
   * Get Subscribers for a tower
   * @param {string} payload.towerNumber get access points assigned to a tower
   * @returns {*}
   */
  async [TOWER_GET_SUBS] ({ dispatch, commit, rootState, state }, payload) {
    try {
      dispatch(_COMMIT_LOG, { message: 'Retrieving subscribers for tower', payload })
      const mapPayload = {
        updateWirelessData: false,
        format: 'json',
        filters: {
          towerNumber: {
            value: [
              payload.towerNumber,
            ],
          },
        },
      }
      const { data } = await PowCustomerService.mapServices(mapPayload)
      commit(TOWER_SET_TOWER_SUBS, data)
      return data
    } catch (e) {
      const processedError = await dispatch('processAxiosError', e)
      dispatch(_COMMIT_LOG, { message: 'Exception retrieving tower access points', error: processedError })
      return []
    }
  },
}

export const mutations = {
  [TOWER_SET_TOWERS] (state, payload) {
    state.towers = payload
  },
  // Update the APs assigned to a tower
  [TOWER_SET_TOWER_APS] (state, payload) {
    console.log('set tower aps payload', payload)
    if (payload && payload.length > 0) {
      const towerId = payload[0].fk_tower_id
      console.log('tower ID: ', towerId)
      // const towerIndex = state.towers.findIndex(t => t.Id === payload[0].tower_id)
      let towerAps = []
      console.log('state-tower aps:', state.towerAps)
      if (state.towerAps.length > 0) {
        towerAps = state.towerAps.filter(c => c.fk_tower_id !== towerId)
        console.log('tower aps FILTERED:', towerAps)
      }
      towerAps = [...towerAps, ...payload]
      console.log('tower aps after concat:', towerAps)

      state.towerAps = towerAps
    }
  },
  // Update the subscribers assigned to a tower
  [TOWER_SET_TOWER_SUBS] (state, payload) {
    console.log('set subs payload', payload)
    if (payload && payload.length > 0) {
      const towerId = payload[0].tower_id
      console.log('tower ID: ', towerId)
      // const towerIndex = state.towers.findIndex(t => t.Id === payload[0].tower_id)
      let towerExtSubs = []
      console.log('state-towersubs:', state.towerSubs)
      if (state.towerSubs.length > 0) {
        towerExtSubs = state.towerSubs.filter(c => c.tower_id !== towerId)
        console.log('towersubs FILTERED:', towerExtSubs)
      }
      towerExtSubs = [...towerExtSubs, ...payload]
      console.log('towerExtSubs after concat:', towerExtSubs)

      state.towerSubs = towerExtSubs
    }
  },
}
export const getters = {
  towers: state => state.towers,
  towerSubs: state => state.towerSubs,
  towerAps: state => state.towerAps,
}
export default {
  state,
  actions,
  mutations,
  getters,
}
